import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { AssetEventComponent } from './components/asset-event.component';
import { AssetEventRoutingModule } from './asset-event-routing.module';

@NgModule({
  declarations: [AssetEventComponent],
  imports: [
    AssetEventRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class AssetEventModule {}

export function loadAssetEventModuleAsChild() {
  return Promise.resolve(AssetEventModule);
}
